import {
  CommoditiesApi,
  CreateCommoditiesCommand,
  CreateCommodityCommand,
  UpdateCommodityCommand,
} from '@billing/app/api'
import { createApiClient } from '@billing/app/http-client'

class CommodityService {
  httpClient = createApiClient(CommoditiesApi)

  async getSuggestedCode(catalogueId?: number, parentCommodityId?: number) {
    const { data } = await this.httpClient.getSuggestedCode(catalogueId, parentCommodityId)
    return data
  }

  async setIsActiveStatus(id: number, isActive: boolean) {
    await this.httpClient.deactivate(id, isActive)
  }

  async loadCommodities() {
    const { data } = await this.httpClient.get()
    return data
  }

  async addCommodity(commodity: CreateCommodityCommand) {
    const { data } = await this.httpClient.create(commodity)
    return data
  }

  async updateCommodity(commodity: UpdateCommodityCommand) {
    const { data } = await this.httpClient.update(commodity)
    return data
  }

  async deleteCommodity(id: number) {
    await this.httpClient._delete(id)
  }

  async createCommoditiesFromCsv(data: CreateCommoditiesCommand) {
    await this.httpClient.createCommodities(data)
  }
}

const commodityService = new CommodityService()

export default commodityService
